import { render, staticRenderFns } from "./SuppliesCompanyEducationCreate.vue?vue&type=template&id=4b1cf251"
import script from "./SuppliesCompanyEducationCreate.vue?vue&type=script&lang=js"
export * from "./SuppliesCompanyEducationCreate.vue?vue&type=script&lang=js"
import style0 from "./SuppliesCompanyEducationCreate.vue?vue&type=style&index=0&id=4b1cf251&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports